module.exports = __webpack_public_path__ + "static/media/checked.e6be44ed.svg";